import { render, staticRenderFns } from "./chillIcon.vue?vue&type=template&id=127d4406&scoped=true"
import script from "./chillIcon.vue?vue&type=script&lang=js"
export * from "./chillIcon.vue?vue&type=script&lang=js"
import style0 from "./chillIcon.vue?vue&type=style&index=0&id=127d4406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d4406",
  null
  
)

export default component.exports